<template>
  <v-menu
    ref="menu"
    :close-on-content-click="false"
    v-model="menu"
    transition="scale-transition"
    offset-y
    full-width
    :nudge-right="40"
    :return-value.sync="currentDate"
  >
    <template v-slot:activator="{ on }">
      <v-text-field v-model="displayDate" :label="label" prepend-icon="event" v-on="on" readonly></v-text-field>
    </template>
    <v-date-picker v-model="currentDate" scrollable locale="en-gb" @change="saveDate(date)">
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';

export default {
  name: 'bill-date-picker',
  data: () => ({
    menu: false,
    date: moment().format('YYY-MM-DD')
  }),
  props: ['billDate', 'billId', 'dateColumn', 'label'],
  computed: {
    currentDate: {
      get() {
        return this.billDate ? moment(this.billDate).format('YYYY-MM-DD') : null;
      },
      set(date) {
        this.date = date;
      }
    },
    displayDate: {
      get() {
        return this.billDate ? moment(this.billDate).format('DD/MM/YYYY') : null;
      },
      set() {}
    }
  },
  methods: {
    ...mapActions(['updateBill']),
    saveDate: function(date) {
      const updates = {};
      updates[this.dateColumn] = date;
      if (this.billId !== null) {
        this.updateBill({
          id: this.billId,
          updates
        });
      }
      this.menu = false;
      this.$emit('changed', date, this.dateColumn);
    }
  }
};
</script>

<style scoped></style>
